module.exports = __webpack_public_path__ + "static/img/2015.c41e1625.jpg";